import React from 'react';
import LegalPage from './LegalPage-new';

function ContactUsPage(): React.ReactElement
{
    return (
        <LegalPage
            eyebrow="Contact Us"
            title="Reach the AcceliQA team"
            summary="Questions about onboarding, support, partnerships, or account help? Use the contact options below and we will route your message to the right team quickly."
            lastUpdated="April 8, 2026"
            sections={[
                {
                    id: 'general-contact',
                    title: 'General Contact',
                    content: (
                        <>
                            <p>
                                For product questions, account help, or general business inquiries, email{' '}
                                <a href="mailto:contact@accelirate.com?subject=AcceliQA%20Contact%20Request">AcceliQADev@accelirate.com</a>.
                            </p>
                            <ul>
                                <li>Customer support and implementation guidance</li>
                                <li>Pricing, demos, and enterprise rollout questions</li>
                                <li>Procurement, security, and compliance follow-ups</li>
                            </ul>
                        </>
                    )
                },
                {
                    id: 'best-way-to-reach-us',
                    title: 'How to Get Faster Help',
                    content: (
                        <>
                            <p>
                                When you contact us, include your organization name, the project or workflow involved, and a short description of what you need. That helps our team respond with the right context.
                            </p>
                            <p>
                                If you are reporting an issue, share the screen, error message, and the exact steps that led to it so we can reproduce it quickly.
                            </p>
                        </>
                    )
                },
                {
                    id: 'response-expectations',
                    title: 'Response Expectations',
                    content: (
                        <>
                            <p>
                                We typically respond to general inquiries within one business day. Priority support requests from active customers are triaged as quickly as possible during standard business hours.
                            </p>
                            <p>
                                If your request is related to billing or subscription changes, mention that in the subject line so it can be routed immediately.
                            </p>
                        </>
                    )
                }
            ]}
            footerNote="Thank you for reaching out to AcceliQA. The more context you share, the faster our team can help with onboarding, troubleshooting, and platform planning."
        />
    );
}

export default ContactUsPage;
